// export const FIREBASE_URL =
// 	"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";

// export const BASE_URL = "https://albu.attrax.digital/api/";

export const BASE_URL = 'https://api.safe-city.pro/api/';
